import React from 'react';

import Box from '@mui/material/Box';

import OndemandVideoOutlined from '@mui/icons-material/OndemandVideoOutlined';

import { useTranslation } from 'react-i18next';

import PortalLayout from '../../../../layout/Portal';
import ParticipantVideo from '../../../../components/content/ParticipantVideo';
import { chartColours } from '../../../../core/constants/colours.constants';
import PageContainer from '../../../../components/content/PageContainer';

function VideoScene() {
  const { t } = useTranslation('portal');

  return (
    <PortalLayout>
      <PageContainer
        title={t('video.title')}
        icon={
          <Box
            sx={{
              width: 54,
              height: 54,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: `${chartColours[5]}26`,
              color: chartColours[5],
              flexShrink: 0,
              border: 1,
              borderColor: `${chartColours[5]}55`,
            }}
          >
            <OndemandVideoOutlined sx={{ fontSize: 34 }} />
          </Box>
        }
      >
        <ParticipantVideo />
      </PageContainer>
    </PortalLayout>
  );
}

export default VideoScene;
